import { useLazyQuery, useQuery } from "@apollo/client";
import { STOCK_SCANS } from "../stock-scan.queries";
import {
  StockScansQuery,
  StockScansQueryVariables,
} from "../../../__generated__/StockScansQuery";

export const useStockScans = (variables: StockScansQueryVariables) => {
  return useQuery<StockScansQuery, StockScansQueryVariables>(STOCK_SCANS, {
    variables,
  });
};

export const useLazyStockScans = () => {
  return useLazyQuery<StockScansQuery, StockScansQueryVariables>(STOCK_SCANS);
};
